import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import './BarChart.css';

const BarChart = () => {
  const chartRef = useRef(null);

  useEffect(() => {
    // 初始化图表实例
    const chartInstance = echarts.init(chartRef.current);

    // 配置项
    const option = {
      title: {
        text: '各区县局指标对比',
        left: 'center',
        textStyle: {
          fontSize: 14,
          fontWeight: 'normal'
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: ['经营绩效', '运营管控', '卷烟营销', '专卖监管'],
        bottom: 0
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '15%',
        top: '15%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      yAxis: {
        type: 'category',
        data: ['福清市局', '长乐区局', '闽侯县局', '连江县局', '罗源县局', '平潭县局', '永泰县局', '闽清县局', '城北区局', '城南区局']
      },
      series: [
        {
          name: '经营绩效',
          type: 'bar',
          itemStyle: { color: '#3B82F6' }, // 蓝色
          data: [92, 88, 85, 83, 80, 78, 75, 72, 90, 87]
        },
        {
          name: '运营管控',
          type: 'bar',
          itemStyle: { color: '#10B981' }, // 绿色
          data: [89, 85, 82, 80, 77, 75, 72, 69, 87, 84]
        },
        {
          name: '卷烟营销',
          type: 'bar',
          itemStyle: { color: '#F59E0B' }, // 金色
          data: [91, 87, 84, 81, 78, 76, 73, 70, 89, 86]
        },
        {
          name: '专卖监管',
          type: 'bar',
          itemStyle: { color: '#8B5CF6' }, // 紫色
          data: [93, 89, 86, 83, 80, 78, 75, 72, 91, 88]
        }
      ]
    };

    // 设置配置项
    chartInstance.setOption(option);

    // 响应窗口大小变化
    const handleResize = () => {
      chartInstance.resize();
    };
    
    window.addEventListener('resize', handleResize);

    // 清理函数
    return () => {
      window.removeEventListener('resize', handleResize);
      chartInstance.dispose();
    };
  }, []);

  return <div ref={chartRef} className="bar-chart"></div>;
};

export default BarChart;